import React from 'react';

import { Form } from '../../../app-components/form/Form';
import { masterDataTheme } from './theme';
import { Image, ScrollView, View } from '@applane/react-core-components';
import { sampleDataUploadImage } from '../../../images';
import { invoke } from '../../../AppServices';
import { Toast } from '../../../app-components';

const MDScreen = (props) => {
  return (
    <ScrollView>
      <View style={masterDataTheme.boxToHoldEverything}>
        <View style={masterDataTheme.leftSideBox}>
          <Form
            type="standard"
            onSubmit={async ({ data }) => {
              await invoke({
                id: 'callingInfinix',
                paramValue: data.masterDataFile,
              });

              Toast.show({
                message: 'Success',
                description: 'Upload Successful',
                type: 'success',
                position: 'top',
                direction: 'right',
                duration: 3000,
              });
            }}
            mandatory={{ masterDataFile: 1 }}
            submitMessage={'File Uploaded Successfully'}
            fieldContainer="topLabel"
            lg={{
              formGroups: [
                {
                  columnsPerRow: 1,
                  fieldVariant: 'filled',
                  groups: [
                    {
                      columns: [
                        {
                          type: 'file',
                          field: 'masterDataFile',
                          mandatory: true,
                        },
                      ],
                    },
                  ],
                },
              ],
            }}
            {...props}
          />
        </View>
        <View style={masterDataTheme.rightSideBox}>
          <View style={masterDataTheme.sampleDataTitle}>Sample Data</View>
          <View style={masterDataTheme.boxToHoldImage}>
            <Image
              style={masterDataTheme.sampleImageProperties}
              source={sampleDataUploadImage}
            />
          </View>
        </View>
      </View>
    </ScrollView>
  );
};

export default MDScreen;
